import React from 'react';
import { SearchIcon } from '@panwds/icons';
import { Tooltip, Input } from '@panwds/react-ui';

const TableFilter = ({ onChange, placeholder = "Search...", value, }) => {
    return (React.createElement(Tooltip, { label: "Search for specific data within the table" },
        React.createElement(Input, { "aria-label": "Table filter", placeholder: placeholder, onChange: onChange, suffix: React.createElement(SearchIcon, { size: "md", className: "tw-text-gray-300 dark:tw-text-gray-400" }), value: value })));
};

export { TableFilter };
//# sourceMappingURL=TableFilter.esm.js.map
